import { http } from './http';

export function getMyActivity() {
  return http.get('/api/v1/auth/me/activity').then((r) => r.data);
}

